module.exports = __webpack_public_path__ + "img/photo-08.0ad92b6e.jpg";